import { authInfoSelect } from "@entities/auth";
import { CSSProperties } from "react";
import { useSelector } from "react-redux";
import { PuffLoader } from "react-spinners";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const { shop } = useSelector(authInfoSelect);

  if (!shop) {
    const cssOverride: CSSProperties = {
      position: "absolute",
      top: "50%",
      left: "50%",
    };
    return <PuffLoader color="#E65E20" cssOverride={cssOverride} />;
  }

  // TODO перенести сюда проверку авторизации пользователя и редирект на логин ???

  return children;
};

export default PrivateRoute;
